/* eslint-env browser */
import axios from 'axios'
import * as React from 'react'

import withTranslator from '../TranslatorProvider'

const PropTypes = require('prop-types')

const isServer = typeof window === 'undefined'
const MapboxLanguage = isServer ? null : require('@mapbox/mapbox-gl-language')

class UserCatchesMap extends React.Component {
  componentDidMount() {
    const { appConfig, userId, translate } = this.props

    const { mapboxgl } = window

    if (mapboxgl) {
      mapboxgl.accessToken = appConfig.config.mapboxAccessToken
      const map = (this.map = new mapboxgl.Map({
        container: this.mapContainer,
        style: 'mapbox://styles/philippeauriach/cjl2jolcz2t6t2rudt3omu8k9',
        maxZoom: 8,
        zoom: 1,
        center: [1, 1],
      }))

      const language = new MapboxLanguage()
      map.addControl(language)
      map.addControl(new mapboxgl.GeolocateControl(), 'bottom-right')
      map.addControl(
        new mapboxgl.ScaleControl({
          maxWidth: 80,
          unit: window.initialState.userUnitSystem === 'IMPERIAL' ? 'imperial' : 'metric',
        }),
        'bottom-left'
      )
      map.addControl(new mapboxgl.NavigationControl(), 'bottom-right')

      map.on('load', function() {
        const sourceId = `fishfriender-user-${window.initialState.userId}`

        map.addSource(sourceId, {
          type: 'vector',
          tiles: [`${window.origin}/api/map/users/${window.initialState.userId}/catches/{z}/{x}/{y}.mvt`],
        })

        const layerColor = '#429F8D'
        const fillOpacity = ['min', 1, ['max', 0.1, ['+', 0.3, ['*', 0.7, ['/', ['get', 'percent'], 100]]]]]

        axios.get(`/api/map/users/${userId}/catchesboundingBox`).then(response => {
          if (response.data && response.data.length > 0) {
            const coordinates = (response.data[0].coordinates || [])[0]
            if (coordinates && coordinates.length === 5) {
              map.fitBounds([coordinates[0], coordinates[2]], { padding: 60 })
            }
          }
        })

        map.addLayer(
          {
            id: 'user-catches-low-level',
            source: sourceId,
            'source-layer': 'low',
            type: 'fill',
            paint: {
              'fill-color': layerColor,
              'fill-opacity': fillOpacity,
            },
            minzoom: 4,
            maxzoom: 9,
          },
          'border-admin-2'
        )

        map.addLayer(
          {
            id: 'user-catches-main-level',
            source: sourceId,
            'source-layer': 'main',
            type: 'fill',
            paint: {
              'fill-color': layerColor,
              'fill-opacity': fillOpacity,
            },
            minzoom: 0,
            maxzoom: 4,
          },
          'border-admin-2'
        )

        map.addLayer({
          id: 'user-catches-hover-low-layer',
          source: sourceId,
          'source-layer': 'low',
          type: 'line',
          paint: {
            'line-color': layerColor,
            'line-width': 1,
          },
          filter: ['==', 'not equals', 'name of polygon'],
        })
        map.addLayer({
          id: 'user-catches-hover-main-layer',
          source: sourceId,
          'source-layer': 'main',
          type: 'line',
          paint: {
            'line-color': layerColor,
            'line-width': 1,
          },
          filter: ['==', 'not equals', 'name of polygon'],
        })

        let popup
        map.on('mousemove', e => {
          const features =
            map.queryRenderedFeatures(e.point, { layers: ['user-catches-low-level', 'user-catches-main-level'] }) || []
          let filter = ['==', 'not equals', 'name of polygon']
          if (features.length) {
            filter = ['==', features[0].properties.name, ['get', 'name']]
          }
          map.setFilter('user-catches-hover-low-layer', filter)
          map.setFilter('user-catches-hover-main-layer', filter)

          if (features.length) {
            map.getCanvas().style.cursor = 'pointer'
            if (popup) {
              popup.remove()
              popup = null
            }
            const popupContent = document.createElement('div')
            const level = features[0].properties
            let tr
            if (level.count > 1) {
              tr = translate('map.catches.plural', { nb: level.count })
            } else {
              tr = translate('map.catches.singular', { nb: level.count })
            }
            popupContent.innerHTML = `<h6>${level.name}</h6>${tr}`
            popup = new mapboxgl.Popup({
              closeOnClick: false,
              closeButton: false,
              offset: {
                bottom: [0, -20],
              },
            })
              .setLngLat(e.lngLat)
              .setDOMContent(popupContent)
              .addTo(map)
          } else {
            map.getCanvas().style.cursor = ''
            if (popup) {
              popup.remove()
              popup = null
            }
          }
        })
      })
    }
  }

  componentWillUnmount() {
    this.map.remove()
  }

  render() {
    const style = {
      width: '100%',
      height: '60vh',
    }

    return (
      <div
        style={style}
        ref={el => {
          this.mapContainer = el
          return el
        }}
      />
    )
  }
}

UserCatchesMap.propTypes = {
  translate: PropTypes.func.isRequired,
  appConfig: PropTypes.object.isRequired,
  userId: PropTypes.string.isRequired,
}

module.exports = withTranslator(UserCatchesMap)
